import { Eleve, EleveDTO } from '@teetsh/app/src/types/eleves';
import parseISO from '@teetsh/app/src/utils/time/parseISO';
import formatISO from '@teetsh/app/src/utils/time/formatISO';
import serializeDateToServer from '@teetsh/app/src/utils/time/serializeDateToServer';
import deserializeDateFromServer from '@teetsh/app/src/utils/time/deserializeDateFromServer';
import { Gender } from '@teetsh/app/src/types/gender';
import _omit from 'lodash-es/omit';
import { isEnrolledAt } from 'queries/eleves/isEnrolledAt';

export function getGenderLabel(gender?: Gender) {
  if (!gender) {
    return null;
  }
  if (gender === 'H') {
    return 'Garçon';
  }
  return 'Fille';
}

export function getGenderLabelKey(gender?: Gender) {
  if (!gender) {
    return null;
  }
  if (gender === 'H') {
    return 'boy';
  }
  return 'girl';
}

export function deserializeEleve(eleve: any, tz: string): Eleve {
  let res = eleve;
  if (eleve.birthday) {
    res = {
      ...res,
      birthday: deserializeDateFromServer(parseISO(eleve.birthday), tz),
    };
  }
  if (eleve.arrivalDate) {
    res = {
      ...res,
      arrivalDate: deserializeDateFromServer(parseISO(eleve.arrivalDate), tz),
    };
  }
  if (eleve.radiationDate) {
    res = {
      ...res,
      radiationDate: deserializeDateFromServer(
        parseISO(eleve.radiationDate),
        tz,
      ),
    };
  }
  if (eleve.gender) {
    res = {
      ...res,
      // TODO: handle gender translation
      genderLabel: getGenderLabel(eleve.gender),
    };
  }
  return {
    ...res,
    isEnrolledAt: (dateParam?: Date) =>
      isEnrolledAt({
        dateParam,
        arrivalDate: res.arrivalDate,
        radiationDate: res.radiationDate,
      }),
  };
}

export function serializeEleve(eleve: Eleve, tz: string): EleveDTO {
  let res: any = _omit(eleve, 'isEnrolledAt');
  if (eleve.birthday) {
    res = {
      ...eleve,
      birthday: formatISO(serializeDateToServer(eleve.birthday, tz)),
    };
  }
  if (eleve.arrivalDate) {
    res = {
      ...eleve,
      arrivalDate: formatISO(serializeDateToServer(eleve.arrivalDate, tz)),
    };
  }
  if (eleve.radiationDate) {
    res = {
      ...eleve,
      radiationDate: formatISO(serializeDateToServer(eleve.radiationDate, tz)),
    };
  }

  return {
    ...res,
    givenName: res.givenName.trim(),
    familyName: res.familyName.trim(),
  };
}
